<script lang="ts">
  import type { ButtonSize } from '$lib/types/components';
  import { twMerge } from 'tailwind-merge';

  export let size: ButtonSize | 'xl' = 'sm';
  export let src: string | null = null;
  export let alt: string | null = null;
  export let showOutline: true | false = false;
  export let nonLazyImg: boolean = false;

  const classes = {
    sizes: {
      sm: 'w-6 h-6',
      md: 'w-8 h-8 md:w-10 md:h-10',
      lg: 'w-14 h-14',
      xl: 'w-18 h-18'
    }
  };
</script>

<img
  class={twMerge(
    'rounded-full object-cover',
    classes.sizes[size],
    showOutline && 'ring-[3px] ring-white',
    $$restProps.class
  )}
  {src}
  {alt}
  {...!nonLazyImg && { loading: 'lazy' }}
/>

<!-- @component
Circular avatar style image. optionally with a border.
## Props
  @prop size: ButtonSize = 'sm';
  @prop src: string;
  @prop alt: string;
  @prop showOutline: true | false = false; -->
